import React from "react";
import styles from "./PuiHighLight.module.css";

export function Highlight({ highlights }: { highlights: string }) {
    return <span className={styles.highlight} dangerouslySetInnerHTML={{ __html: highlights }} />;
}

// タイトル、説明、発表者をハイライトする
export function PuiHighLight({ highlights, text }: { highlights?: string; text: string }) {
    if (highlights && highlights.length > 0) {
        return <Highlight highlights={highlights} />;
    }

    return <span>{text}</span>;
}
